import { makeHook } from "../../utils/makeSingleArgHook";
import getProposal, { proposalUrl } from "../requests/getProposal";
export function proposalKeyMaker(proposalId) {
    return [proposalUrl(proposalId)];
}
const useGetProposal = makeHook(getProposal, (proposalId) => proposalKeyMaker(proposalId));
export default useGetProposal;
//# sourceMappingURL=useGetProposal.js.map